import { React, useEffect, useState } from "react";
import Facebook from "@material-ui/icons/Facebook";
import Twitter from "@material-ui/icons/Twitter";
import WhatsApp from "@material-ui/icons/WhatsApp";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import Youtube from "@material-ui/icons/YouTube";
import Instagram from "@material-ui/icons/Instagram";
import Mail from "@material-ui/icons/Mail";
import "../../styles/footer.scss";
import { Col, Modal, Row, Card } from "react-bootstrap";
import "./tooltip.css";
import Tooltip from "./Tooltip.js";
import CloudSocial from "../../asset/image/CloudSocialLogo.svg";
import { Link, Redirect } from "react-router-dom";
import { Star, Policy, GDPR, Security } from "../../asset/json/footer";
import { Map } from "@material-ui/icons";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import { FaArrowCircleUp } from "react-icons/fa";

const Footer = () => {
  const [date, setDate] = useState();

  const getYear = () => setDate(new Date().getFullYear());

  const [showScroll, setShowScroll] = useState(false);
  const checkScrollTop = () => {
    if (!showScroll && window.pageYOffset > 400) {
      setShowScroll(true);
    } else if (showScroll && window.pageYOffset <= 400) {
      setShowScroll(false);
    }
  };
  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  window.addEventListener("scroll", checkScrollTop);

  useEffect(() => {
    handleClose();
    getYear();
    return () => {};
  }, []);
  const [show, setShow] = useState(false);
  const [policy, setPolicy] = useState("");
  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
  };

  const [display, setDisplay] = useState(false);
  const [gdpr, setGdpr] = useState("");
  const handleClose1 = () => setDisplay(false);
  const handleShow1 = () => {
    setDisplay(true);
  };
  const [displaySecurity, setDisplaySecurity] = useState(false);
  const [security, setSecurity] = useState("");
  const handleClose2 = () => setDisplaySecurity(false);
  const handleShow2 = () => {
    setDisplaySecurity(true);
  };
  return (
    <div className="footer mb-5">
      <Row className="socialRow">
        <Col>
          <SocialIcon />
        </Col>
        <FaArrowCircleUp
          className="scrollTop"
          onClick={scrollTop}
          style={{ height: 40, display: showScroll ? "flex" : "none" }}
        />
      </Row>

      <Row className="policy-div">
        <Col md={4} xl={3}>
          <span className="data policy">
            Copyright @ {date} CloudSocial Technologies Pte Ltd.
          </span>
        </Col>
        <Col md={4} xl={6}>
          <div className="policy policy-faq">
            <Tooltip content="FAQ" direction="top" className="policy-text">
              <Link className="policy-text" to="/faqs">
                FAQ
              </Link>
            </Tooltip>
            <Tooltip content="Privacy Policy" direction="top">
              {/* <a
                href="https://www.iubenda.com/privacy-policy/84213336"
                class="iubenda-nostyle no-brand iubenda-noiframe iubenda-embed iubenda-noiframe "
              >
                Privacy Policy
              </a> */}
              <Link className="policy-text" to="/privacy-policy">
                Privacy Policy
              </Link>
            </Tooltip>
            <Tooltip content="Cookie Policy" direction="top">
              <a
                href="https://www.iubenda.com/privacy-policy/84213336/cookie-policy"
                class="iubenda-nostyle no-brand iubenda-noiframe iubenda-embed iubenda-noiframe "
              >
                Cookie Policy
              </a>
            </Tooltip>
            <Tooltip content="Terms and Conditions" direction="top">
              {/* <a
                href="https://www.iubenda.com/terms-and-conditions/84213336"
                class="iubenda-nostyle no-brand iubenda-noiframe iubenda-embed iubenda-noiframe "
              >
                Terms and Conditions
              </a> */}
              <Link className="policy-text" to="/terms-of-service">
                Terms and Conditions
              </Link>
            </Tooltip>

            <Tooltip content="GDPR" direction="top">
              <Link className="policy-text" to="/gdpr">
                GDPR
              </Link>
            </Tooltip>
            <Tooltip content="Security" direction="top">
              <Link className="policy-text" to="/security">
                Security
              </Link>
            </Tooltip>
          </div>
        </Col>
        {/* <Col></Col> */}
        <Col md={4} xl={3}>
          <div className="policy star">
            {Star.map(({ img, url, title, id }) => (
              <div key={id}>
                <Tooltip content={title} direction="top">
                  <a
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="star"
                  >
                    <img border="0" className="star" src={img} alt={title} />
                  </a>
                </Tooltip>
              </div>
            ))}
          </div>
        </Col>
        <Col></Col>
      </Row>
      <div style={{ display: "none" }}>
        {/* <Link to="/detail-pricing">AllPricing</Link> */}
        <Link to="/resources/video">Video</Link>
        <Link to="/blog">blog</Link> 
        {/* <Link to="/solutions">solutions</Link> */}
        <Link to="/resources/literature">literature</Link>
        {/* <Link to="/managed-services">managedService</Link> */}
        {/* <Link to="/schedule-service">scheduleManagedService</Link> */}
        <Link to="/privacy-policy">policy</Link>
        <Link to="/terms-of-service">terms</Link>
        {/* <Link to="/terms-privacy-policy-2">policy</Link>
        <Link to="/terms-privacy-policy-2-2">terms</Link> */}
        <Link to="/integration">Integration</Link>
        <Link to="/cloud-insights">CloudInsights</Link>
        <Link to="/home1">home1</Link>
        <Link to="/home2">home2</Link>
      </div>
    </div>
  );
};
export default Footer;

export function SocialIcon() {
  return (
    <div>
      <div className="icon ">
        <a
          href="https://www.facebook.com/CloudSocial-2099206000345885/"
          target="_blank"
          rel="noopener noreferrer"
          className="design"
        >
          <Facebook />
        </a>
        <a
          href="https://twitter.com/Cloudsocial_"
          target="_blank"
          rel="noopener noreferrer"
          className="design"
        >
          <Twitter />
        </a>
        <a
          href="https://wa.me/919372923073?text=I%20am%20interested%20to%20explore%20CloudSocial%20free%20trial%20for%207%20days"
          target="_blank"
          rel="noopener noreferrer"
          className="design"
        >
          <WhatsApp />
        </a>
        <a
          href="https://www.linkedin.com/company/cloudsocial-io/"
          target="_blank"
          rel="noopener noreferrer"
          className="design"
        >
          <LinkedInIcon />
        </a>
        <a
          href="https://www.youtube.com/channel/UCcdcLfRsJmTRax5L3XqbOYQ"
          target="_blank"
          rel="noopener noreferrer"
          className="design"
        >
          <Youtube />
        </a>
        <a
          href="https://www.instagram.com/cloudsocial.io/"
          target="_blank"
          rel="noopener noreferrer"
          className="design"
        >
          <Instagram />
        </a>
        {/* <Tooltip content="Google My Business" direction="right">
          <a
            href="https://www.google.com/maps/place/CloudSocial+Technologies+Pte+Ltd/@18.3360146,86.125683,4z/data=!4m5!3m4!1s0x0:0xdd29cb5aa409d110!8m2!3d18.3360146!4d86.125683?sa=X&ved=2ahUKEwigw4fQ27_qAhWXXCsKHc5xAh0Q_BIwCnoECBAQCA&shorturl=1"
            target="_blank"
            rel="noopener noreferrer"
            className="design"
          >
            <GMB />
          </a>
        </Tooltip> */}
        <a
          href="https://www.google.com/maps/place/CloudSocial+Technologies+Pte+Ltd/@18.3360146,86.125683,4z/data=!4m5!3m4!1s0x0:0xdd29cb5aa409d110!8m2!3d18.3360146!4d86.125683?sa=X&ved=2ahUKEwigw4fQ27_qAhWXXCsKHc5xAh0Q_BIwCnoECBAQCA&shorturl=1"
          target="_blank"
          rel="noopener noreferrer"
          className="design"
        >
          <LocationOnIcon />
        </a>
      </div>
      <hr className="icon-divider" />
    </div>
  );
}
